if (!customElements.get('media-reveal')) {
  class MediaReveal extends HTMLElement {
    connectedCallback() {
      this.reveal = this.querySelector('.imr__reveal');
      this.handle = this.querySelector('.imr__handle');
      this.beforeFrame = this.querySelector('.imr__frame--before');
      this.afterFrame = this.querySelector('.imr__frame--after');

      if (!this.reveal || !this.handle || !this.beforeFrame || !this.afterFrame) return;

      this.dragging = false;
      this.setPosition(50);

      this.handle.addEventListener('pointerdown', (event) => {
        this.dragging = true;
        this.handle.setPointerCapture(event.pointerId);
        event.preventDefault();
      });

      this.handle.addEventListener('pointermove', (event) => {
        if (!this.dragging) return;
        const rect = this.reveal.getBoundingClientRect();
        this.setPosition(((event.clientX - rect.left) / rect.width) * 100);
      });

      this.handle.addEventListener('pointerup', () => {
        this.dragging = false;
      });

      this.handle.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.setPosition(this.position - 5);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.setPosition(this.position + 5);
        }
      });
    }

    setPosition(value) {
      this.position = Math.min(100, Math.max(0, value));
      this.handle.style.left = `${this.position}%`;
      this.beforeFrame.style.clipPath = `inset(0 ${100 - this.position}% 0 0)`;
      this.afterFrame.style.clipPath = `inset(0 0 0 ${this.position}%)`;
      this.handle.setAttribute('aria-valuenow', Math.round(this.position));
    }
  }

  customElements.define('media-reveal', MediaReveal);
}
